import { MobileSettingsKeys, SettingsKeys } from './appSettingsKeys';
import { cleanNulls } from './utils';
const stylesParamFontKeyToAppSettingsMapper = {
  widgetTitleFont: SettingsKeys.MULTI_OFFERINGS_TITLE_FONT,
  filterTitleFont: SettingsKeys.CATEGORY_NAME_FONT,
  dropdownTextFont: MobileSettingsKeys.MOBILE_CATEGORY_NAME_FONT,
  serviceNameFont: SettingsKeys.OFFERING_NAME_FONT,
  serviceTagLineFont: SettingsKeys.OFFERING_TAGLINE_FONT,
  moreInfoButtonFont: SettingsKeys.OFFERING_MORE_INFO_LABEL_FONT,
  serviceDetailsFont: SettingsKeys.OFFERING_DETAILS_FONT,
  courseAvailabilityFont: SettingsKeys.COURSE_AVAILABILITY_FONT,
  bookButtonFont: SettingsKeys.BUTTON_TEXT_FONT,
  explorePlansFont: SettingsKeys.EXPLORE_PLANS_FONT,
  [SettingsKeys.CATEGORY_NAME_FONT]: SettingsKeys.CATEGORY_NAME_FONT,
  [SettingsKeys.OFFERING_NAME_FONT]: SettingsKeys.OFFERING_NAME_FONT,
  MULTI_OFFERINGS_TITLE_FONT: SettingsKeys.MULTI_OFFERINGS_TITLE_FONT,
  MOBILE_CATEGORY_NAME_FONT: MobileSettingsKeys.MOBILE_CATEGORY_NAME_FONT,
  COURSE_AVAILABILITY_FONT: SettingsKeys.COURSE_AVAILABILITY_FONT,
  OFFERING_TAGLINE_FONT: SettingsKeys.OFFERING_TAGLINE_FONT,
  OFFERING_MORE_INFO_LABEL_FONT: SettingsKeys.OFFERING_MORE_INFO_LABEL_FONT,
  OFFERING_DETAILS_FONT: SettingsKeys.OFFERING_DETAILS_FONT,
  BUTTON_TEXT_FONT: SettingsKeys.BUTTON_TEXT_FONT,
  EXPLORE_PLANS_FONT: SettingsKeys.EXPLORE_PLANS_FONT
};
export function mergeAppSettingsNumbersToStyleParamsFonts(appSettings, fixLegacyFonts) {
  function mapFont(_ref) {
    let {
      appSettingsFont
    } = _ref;
    if (fixLegacyFonts && appSettingsFont) {
      const origFontFamily = appSettingsFont.family;
      if (origFontFamily != null && origFontFamily.startsWith('font-family')) {
        const fontFamily = origFontFamily.split(',').shift();
        const fontFamilyName = fontFamily == null ? void 0 : fontFamily.split(':').pop();
        const fontValue = fontFamilyName == null ? void 0 : fontFamilyName.slice(1, -1);
        return {
          ...appSettingsFont,
          family: fontValue
        };
      }
    }
    return appSettingsFont || null;
  }
  const newFonts = {};
  Object.keys(stylesParamFontKeyToAppSettingsMapper).forEach(styleParamsFontKey => {
    newFonts[styleParamsFontKey] = mapFont({
      appSettingsFont: appSettings[stylesParamFontKeyToAppSettingsMapper[styleParamsFontKey]]
    });
  });
  return cleanNulls(newFonts);
}
//# sourceMappingURL=mergeFonts.js.map